import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContactContext, useProviderSection } from "@/contexts/contact";
import { useI18n } from "@/shared/hooks";
import { useContactingTestId } from "@/hooks";
import { PublisherTypeEnum } from "@/types";
import { Box } from "@gemini/core";
import { Divider, Modal } from "@gemini/ui";
import { useState } from "react";
import { FormProvider, useFormContext } from "react-hook-form";
import { ContactFormValidationMessage } from "../ContactForm/ContactFormValidationMessage";
import { ContactFormWithLead } from "../ContactForm/ContactFormWithLead";
import { ContactInfos } from "../ContactInfos";
import { SuggestPriceCalculator } from "./SuggestPriceCalculator";
export const SuggestPriceModal = () => {
    var _a;
    const { t } = useI18n();
    const rootTestId = useContactingTestId("SuggestPriceModal");
    const formContext = useFormContext();
    const errors = ((_a = formContext === null || formContext === void 0 ? void 0 : formContext.formState) === null || _a === void 0 ? void 0 : _a.errors) || {};
    const { closeModal, suggestPriceIsOpen, toggleSuggestPriceModal, methods } = useContactContext();
    const { intermediaryCard, publisherType, isPrivateOwner } = useProviderSection();
    const [hasError, setHasError] = useState(false);
    const onOpenChange = () => {
        toggleSuggestPriceModal({
            av_zone: "suggest_a_price",
            legacyTrackingInfos: "suggest_a_price",
        });
    };
    return (_jsx(FormProvider, { ...methods, children: _jsxs(Modal, { title: t("contact.cta.suggest_price"), titleAs: "h2", trigger: () => null, isOpen: suggestPriceIsOpen, onOpenChange: onOpenChange, isDismissable: true, children: [!hasError && (_jsxs(Box, { children: [_jsx(Divider, { marginBottom: "spacing.12", "aria-hidden": "true" }), _jsx(ContactInfos, { testId: `${rootTestId}.IntermediaryCard`, title: intermediaryCard.title, subtitle: publisherType && PublisherTypeEnum[publisherType]
                                ? t(PublisherTypeEnum[publisherType])
                                : intermediaryCard.subtitle, logoUrl: intermediaryCard.logoUrl, logoHref: intermediaryCard.logoHref, isPhysicalPerson: isPrivateOwner }), _jsx(Divider, { marginVertical: "spacing.12", "aria-hidden": "true", marginBottom: "spacing.24" }), errors && (_jsx(ContactFormValidationMessage, { errors: errors, testId: rootTestId })), _jsx(Box, { marginTop: "spacing.24", typography: {
                                "breakpoint.base": "typography.body.16.regular",
                            }, children: t("contact.form.suggest_price.info") }), _jsx(SuggestPriceCalculator, {})] })), _jsx(ContactFormWithLead, { av_zone: "suggest_a_price", isModal: true, close: closeModal, onError: () => setHasError(true) })] }) }));
};
